import React, { Fragment } from "react";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import AboutSection from "../../components/AboutComponents/AboutSection/AboutSection";
import FeatureSection from "../../components/AboutComponents/FeatureSection/FeatureSection";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import SEO from "../../components/SEO/SEO";

const AboutPage: React.FC = () => {
  return (
    <Fragment>
      <SEO 
        title="About TorqAI | The AI Automation Agency Building Digital Workforces" 
        description="Learn how TorqAI is transforming business operations with intelligent digital workers. We specialize in AI voice, chat, and automation solutions."
        canonicalUrl="https://torqai.ca/about"
      />
      <div className='about-page inner-page'>
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <PageTitle pageTitle="About Us" pagesub="About Us" />
            <AboutSection />
            <FeatureSection />
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default AboutPage;
